module.exports = __webpack_public_path__ + "img/maria-emilia-iturralde-byn.109c1bf6.jpg";